import { CustomType } from "app/core/shared/shared.type";

export const wellStructureTypeData: CustomType[] = [
  {
    id: '1',
    label: 'Drytree',
    value: 1
  },
  {
    id: '2',
    label: 'Subsea',
    value: 2
  },
  {
    id: '3',
    label: 'Land',
    value: 3
  }
]
